import React from 'react';
import { Button, Modal, Toast, Badge } from 'antd-mobile';
import {post} from '../../utils/request';
import { href } from '../../utils/util';
import BGImg from './image/BG.png';
import BZImg from './image/buzhou.png';
import ZJ1 from './image/ZJ1.png';
import ZJ3 from './image/ZJ3.png';
import InvitationEdit from '../modules/edit';
import InvitationEvent from '../modules/InvitationEvent';
import InvitationLogin from '../modules/login';
import cookies from 'js-cookie';
import api from './api';
import { wxfx } from '../../utils/wxfx.js';

import './index.less';

class InvitationIndex extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            editType: false,
            eventType: false,
            urlOps: {},
            loginType: false,
            selectInviteList: [],
            selectInvite: ''
        };
    }

    componentDidMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            console.log(ops)
            if(ops.isShare && (ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken)){
                Toast.fail('请登录APP再进行操作',999);
                return;
            }
            
            this.setState({
                urlOps: ops
            },()=>{
                if((ops.app_stoken && ops.app_stoken != 'null') || cookies.get('session_key')){
                    this.getSelectInvite();
                    this.getSelectInviteList();
                }
                this.fx();
            });
        }
    }

    fx() {
        var mobile = '';
        if(cookies.get('session_key')){
            mobile = cookies.get('InvitationLoginMobile');
        }else{
            mobile = this.state.urlOps.mobile;
        }
        wxfx({
            title: '邀请租车赚现金，每台奖励500元',
            imgUrl: 'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUDiAMB4pAAD43t09MkM257.png',
            desc: `电动货车低价租，邀请越多奖励越多，每台奖励500元`,
            url: `${window.location.origin}${window.location.pathname}#/InvitationIndex?mobile=${mobile}`
        });
        
        this.appShare({
            title: '邀请租车赚现金，每台奖励500元',
            url: `${window.location.origin}${window.location.pathname}#/InvitationIndex?mobile=${mobile}`,
            cotent: `电动货车低价租，邀请越多奖励越多，每台奖励500元`,
            img:'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUDiAMB4pAAD43t09MkM257.png'
        }, true);
    }

    // 我的邀请人
    getSelectInvite (){
        let url = '';
        if(this.state.urlOps.app_stoken){
            url = api.selectInvite + '?app_stoken=' + this.state.urlOps.app_stoken;
        }else{
            url = api.selectInvite + '?session_key=' + cookies.get('session_key');
        }
        post({
            url: url, 
            data: {}
        }).then((res) => {
            console.log('我的邀请人', res);
            if(res.result === 'success'){
                this.setState({
                    selectInvite: res.data ? res.data.invitePhoneNumber : ''
                })
            }else{
                // console.log(res)
                if(res.code == '-1'){
                    cookies.remove('session_key');
                    cookies.remove('InvitationLoginMobile');
                    Toast.info('登录失效',1);
                }else{
                    Toast.info('我的邀请人获取失败',1);
                }
            }
        }, (res)=>{
            // console.log(res)
            if(res.code == '-1'){
                cookies.remove('session_key');
                cookies.remove('InvitationLoginMobile');
                Toast.info('登录失效',1);
            }else{
                Toast.info('我的邀请人获取失败',1);
            }
        });
    }

    // 修改邀请人
    determineInvite (tel){
        let url = '';
        if(this.state.urlOps.app_stoken){
            url = api.determineInvite + '?app_stoken=' + this.state.urlOps.app_stoken;
        }else{
            url = api.determineInvite + '?session_key=' + cookies.get('session_key');
        }
        post({
            url: url, 
            data: {
                invitePhoneNumber: tel
            }
        }).then((res) => {
            console.log('修改邀请人', res);
            if(res.result === 'success'){
                this.getSelectInvite();
                this.setState({
                    editType: false
                });
            }else{
                if(res.code == '-1'){
                    cookies.remove('session_key');
                    cookies.remove('InvitationLoginMobile');
                    Toast.info('登录失效',1);
                }else{
                    Toast.info(res.msg.indexOf('参数错误:') > -1 ? res.msg.replace('参数错误:','') : '',1);
                }
            }
        }, (res)=>{
            if(res.code == '-1'){
                cookies.remove('session_key');
                cookies.remove('InvitationLoginMobile');
                Toast.info('登录失效',1);
            }else{
                Toast.info('修改邀请人失败',1);
            }
        });
    }

    // 战绩列表
    getSelectInviteList (){
        let url = '';
        if(this.state.urlOps.app_stoken){
            url = api.selectInviteList + '?app_stoken=' + this.state.urlOps.app_stoken;
        }else{
            url = api.selectInviteList + '?session_key=' + cookies.get('session_key');
        }
        post({
            url: url, 
            data: {
                pageSize: 1000,
                skipCount: 0
            }
        }).then((res) => {
            console.log('战绩列表', res);
            if(res.result === 'success'){
                this.setState({
                    selectInviteList: res.data
                })
            }else{
                console.log(res)
                if(res.code == '-1'){
                    cookies.remove('session_key');
                    cookies.remove('InvitationLoginMobile');
                    Toast.info('登录失效',1);
                }else{
                    Toast.info('战绩列表获取失败',1);
                }
            }
        }, (res)=>{
            console.log(res)
            if(res.code == '-1'){
                cookies.remove('session_key');
                cookies.remove('InvitationLoginMobile');
                Toast.info('登录失效',1);
            }else{
                Toast.info('战绩列表获取失败',1);
            }
        });
    }
    InviteListHtml() {
        let {selectInviteList} = this.state;
        for(var i=0;i<selectInviteList.length;i++){
            html += ``
        }
        let html = selectInviteList.map((item,index)=>{
            return (
                <div key={index}>
                    <div>{item.phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")}</div>
                    <div>{item.gmtCreate.split(' ')[0]}</div>
                    <div>邀请中</div>
                </div>
            )
        });
        return html;
    }
    
    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是否web应该程序，没有头部与底部
        };
    }

    appShare(ops, shareType) {
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                if(shareType){
                    window.webkit.messageHandlers.showShare.postMessage(ops);
                }else{
                    window.webkit.messageHandlers.share.postMessage(ops);
                }
            }
        } else {
            if(window.huilian){
                if(shareType){
                    window.huilian.showShareWeixin(ops.url, ops.title, ops.cotent, ops.img);
                }else{
                    window.huilian.shareWeixin(ops.url, ops.title, ops.cotent, ops.img);
                }
            }
        }
    }

    render() {
        return (
            <div className="InvitationIndexBox">
                <img src={BGImg} />
                {this.state.urlOps.isShare ? (
                    <a className="YQ" onClick={()=>{
                        if(this.state.urlOps.app_stoken || cookies.get('session_key')){
                            this.appShare({
                                url: `${window.location.origin}${window.location.pathname}#/InvitationOpen?mobile=${this.state.urlOps.mobile}`,
                                title: '加入慧联租车，享”三优租车“服务',
                                cotent: `您的好友${this.state.urlOps.mobile.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")}邀请您加入慧联租车`,
                                img:'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUFeAc4IdAADrlgkZLDU935.png'
                            }, false);
                        }else{
                            this.setState({
                                loginType: true
                            });
                        }
                    }}></a>
                ) : (
                    <a className="SC" onClick={()=>{
                        if(this.state.urlOps.app_stoken || cookies.get('session_key')){
                            href(`/InvitationShareImg?url=${window.location.origin}${window.location.pathname}#/InvitationOpen?mobile=${cookies.get('InvitationLoginMobile')}`);
                        }else{
                            this.setState({
                                loginType: true
                            });
                        }
                    }}></a>
                )}
                {this.state.urlOps.app_stoken || cookies.get('session_key') ? '': (
                    <div className="gunDongBox">
                        <div className="gunDong">
                            <p>186****9659推荐2人，轻卡3辆，已提现1500元</p>
                            <p>135****5651推荐1人，轻卡2辆，已提现1000元</p>
                            <p>159****6763推荐1人，轻卡1辆，已提现500元</p>
                            <p>186****3223推荐3人，轻卡1辆，已提现500元</p>
                            <p>185****9969推荐1人，轻卡1辆，已提现500元</p>
                            <p>185****9958推荐2人，轻卡1辆，已提现500元</p>
                            <p>188****9170推荐2人，轻卡5辆，已提现1000元</p>
                            <p>131****2424推荐1人，轻卡1辆，已提现500元</p>
                            <p>185****8666推荐4人，轻卡4辆，已提现2000元</p>
                            <p>134****1576推荐1人，轻卡1辆，已提现500元</p>
                            <p>186****8156推荐5人，轻卡1辆，已提现500元</p>
                            <p>133****7898推荐3人，轻卡1辆，已提现500元</p>
                            <p>186****9066推荐3人，轻卡2辆，已提现1000元</p>
                            <p>151****1015推荐2人，轻卡2辆，已提现1000元</p>
                            <p>185****2027推荐1人，轻卡1辆，已提现500元</p>
                            <p>187****7025推荐1人，轻卡1辆，已提现500元</p>
                            <p>186****5028推荐1人，轻卡2辆，已提现1000元</p>
                            <p>139****3028推荐2人，轻卡2辆，已提现1000元</p>
                            <p>187****3889推荐1人，轻卡2辆，已提现1000元</p>
                            <p>151****6876推荐2人，轻卡3辆，已提现1500元</p>
                            <p>156****8552推荐1人，轻卡1辆，已提现500元</p>
                            <p>182****1030推荐1人，轻卡1辆，已提现500元</p>
                            <p>158****9993推荐1人，轻卡2辆，已提现1000元</p>
                        </div>
                    </div>
                )}
                {this.state.urlOps.app_stoken || cookies.get('session_key') ? (
                    <div className="YQR">
                        邀请我的人：{this.state.selectInvite ? this.state.selectInvite.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2") : '空'}
                        <a onClick={()=>{
                            this.setState({
                                editType: true
                            });
                        }}>修改</a>
                    </div>
                    ) : ''}
                <img src={BZImg} />                
                <a className="GLBtn" onClick={()=>{
                    console.log(111)
                    this.setState({
                        eventType: true
                    });
                }}><span>查 看 赚 钱 攻 略</span></a>
                {this.state.urlOps.app_stoken || cookies.get('session_key') ? (
                    <div className="ZJBox">
                        <img src={ZJ1} /><div className="ZJHead">
                            <div>被邀请人</div>
                            <div>邀请时间</div>
                            <div>邀请状态</div>
                        </div><div className="ZJList">
                            <div>
                                {this.InviteListHtml()}
                            </div>
                        </div><img src={ZJ3} />
                    </div>
                ) : ''}
                {this.state.editType ? (
                    <InvitationEdit 
                        onQuery={(tel)=>{
                            this.determineInvite(tel);
                        }}
                        onQuit={(editType)=>{
                            this.setState({
                                editType
                            },()=>{
                                this.getSelectInvite();
                            });
                        }}
                    />
                ) : ''}
                {this.state.eventType ? (
                    <InvitationEvent
                        onQuit={(eventType)=>{
                            this.setState({
                                eventType
                            });
                        }}
                    />
                ) : ''}
                {this.state.loginType ? (
                    <InvitationLogin
                        invitePhoneNumber={this.state.urlOps.mobile}
                        onQuit={(loginType,mobile)=>{
                            this.setState({
                                loginType,
                                mobile
                            },()=>{
                                this.getSelectInviteList();
                                this.fx();
                            });
                        }}
                    />
                ) : ''}
            </div>
        );
    }
}
export default InvitationIndex;


// WEBPACK FOOTER //
// ./src/invitation/index/index.js